import config from '../../config';

// this integration is needed only for enabling in app messages from customer.io directly
// all the rest events are being send through segment (and there internally redirected to customer.io)

let isInitiated = false;

export const getScriptAttrs = () => {
    if (!config.customerio.enabled) {
        return undefined;
    }

    if (!isInitiated) {
        window._cio = window._cio || [];
        const a = function (f: $TSFixMe) {
            return function (...args: $TSFixMe[]) {
                window._cio?.push([f].concat(Array.prototype.slice.call(args, 0)));
            };
        };
        const b = ['load', 'identify', 'sidentify', 'track', 'page', 'on', 'off'];
        for (let c = 0; c < b.length; c++) {
            if (window._cio) {
                window._cio[b[c]!] = a(b[c]);
            }
        }
        isInitiated = true;
    }

    return {
        type: 'text/javascript',
        src: 'https://assets.customer.io/assets/track.js',
        id: 'cio-tracker',
        async: true,
        'data-site-id': config.customerio.siteId,
        'data-use-array-params': true,
        'data-use-in-app': true,
        'data-auto-track-page': false
    };
};
